/** 与登录态相关的 localStorage 键（避免 request 与 auth 模块循环依赖时单独维护） */

import { secureLocalStorage } from '@/utils/secureLocalStorage'
export const TOKEN_KEY = 'token'

/** 密码登录「记住我」：仅缓存账号（用户名），不涉及后端与密码 */
export const LOGIN_REMEMBER_USERNAME_KEY = 'auth_loginRememberUsername'

export function getRememberedLoginUsername(): string | null {
  try {
    const s = secureLocalStorage.getItem(LOGIN_REMEMBER_USERNAME_KEY)
    return s != null && s.trim() !== '' ? s.trim() : null
  } catch {
    return null
  }
}

export function setRememberedLoginUsername(username: string | null | undefined): void {
  try {
    const u = username != null ? String(username).trim() : ''
    if (!u) secureLocalStorage.removeItem(LOGIN_REMEMBER_USERNAME_KEY)
    else secureLocalStorage.setItem(LOGIN_REMEMBER_USERNAME_KEY, u)
  } catch {
    // 存储失败时忽略
  }
}

export const USER_REGION_CODE_KEY = 'user_regionCode'

export const USER_ORG_ID_KEY = 'user_orgId'

/** 姓名、部门、角色（与 getSimpleLoginUser 成功后写入） */
export const USER_REAL_NAME_KEY = 'user_realName'
export const USER_DEPARTMENT_KEY = 'user_department'
export const USER_ROLE_KEY = 'user_role'

/**
 * `GET /auth/b/getSimpleLoginUser` 解包后的业务对象 JSON（与接口 data 一致，供刷新页、业务回填等使用）
 */
export const SIMPLE_LOGIN_USER_JSON_KEY = 'auth_simpleLoginUserJson'

export function persistSimpleLoginUserJson(payload: unknown): void {
  try {
    if (payload == null) {
      secureLocalStorage.removeItem(SIMPLE_LOGIN_USER_JSON_KEY)
      return
    }
    secureLocalStorage.setItem(SIMPLE_LOGIN_USER_JSON_KEY, JSON.stringify(payload))
  } catch {
    // 存储配额或序列化失败时忽略
  }
}

/** 读取最近一次缓存的简要登录用户 JSON；解析失败返回 null */
export function getStoredSimpleLoginUserJson<T = Record<string, unknown>>(): T | null {
  try {
    const s = secureLocalStorage.getItem(SIMPLE_LOGIN_USER_JSON_KEY)
    if (s == null || s === '') return null
    return JSON.parse(s) as T
  } catch {
    return null
  }
}

export function clearUserRegionOrgLocal(): void {
  secureLocalStorage.removeItem(USER_REGION_CODE_KEY)
  secureLocalStorage.removeItem(USER_ORG_ID_KEY)
}

export function persistUserDisplayInfo(info: {
  realName: string
  department: string
  role: string
}): void {
  const name = info.realName != null ? String(info.realName).trim() : ''
  const dept = info.department != null ? String(info.department).trim() : ''
  const role = info.role != null ? String(info.role).trim() : ''
  if (name) secureLocalStorage.setItem(USER_REAL_NAME_KEY, name)
  else secureLocalStorage.removeItem(USER_REAL_NAME_KEY)
  if (dept) secureLocalStorage.setItem(USER_DEPARTMENT_KEY, dept)
  else secureLocalStorage.removeItem(USER_DEPARTMENT_KEY)
  if (role) secureLocalStorage.setItem(USER_ROLE_KEY, role)
  else secureLocalStorage.removeItem(USER_ROLE_KEY)
}

export function clearUserDisplayLocal(): void {
  secureLocalStorage.removeItem(USER_REAL_NAME_KEY)
  secureLocalStorage.removeItem(USER_DEPARTMENT_KEY)
  secureLocalStorage.removeItem(USER_ROLE_KEY)
}

export function getStoredUserRealName(): string | null {
  return secureLocalStorage.getItem(USER_REAL_NAME_KEY)
}

export function getStoredUserDepartment(): string | null {
  return secureLocalStorage.getItem(USER_DEPARTMENT_KEY)
}

export function getStoredUserRole(): string | null {
  return secureLocalStorage.getItem(USER_ROLE_KEY)
}

/** 清空 token 与用户信息相关本地存储（不调用退出接口） */
export function clearLocalAuthStorage(): void {
  secureLocalStorage.removeItem(TOKEN_KEY)
  secureLocalStorage.removeItem(SIMPLE_LOGIN_USER_JSON_KEY)
  clearUserRegionOrgLocal()
  clearUserDisplayLocal()
}
